<script>
    import { createEventDispatcher, onMount } from "svelte";
    import ViewRewards from "./ViewRewards.svelte";
    import Fa from "svelte-fa";
    import { faArrowRight, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
    import Button from "../../ui/Button.svelte";
    import Rewards from "./Rewards.svelte";
    import EditMilestone from "./EditMilestone.svelte";

    export let milestone;
    export let max_stamp_count;

    $: console.log(milestone);

    const dispatch = createEventDispatcher();

    function remove() {
        dispatch("remove", milestone);
    }
</script>

<div class="milestone">
    <div class="condition">
        <span class="stamps">
            <b>{milestone.stamp_count}</b> Stempel
        </span>
        <span class="arrow">
            <Fa icon={faArrowRight}/>
        </span>
    </div>
    <div class="rewards">
        <Rewards bind:rewards={milestone.rewards} type={milestone.type} on:save={(e) => dispatch("edit", milestone)}/>
    </div>
    <div class="actions">
        <!-- <Button transparent on:click={edit}>
            <Fa
                slot="icon"
                icon={faPen}
            />
        </Button> -->
        <EditMilestone bind:milestone {max_stamp_count} on:edit={(e) => dispatch("edit", milestone)}></EditMilestone>
        <Button transparent on:click={remove}>
            <Fa
                slot="icon"
                icon={faTrash}
            />
        </Button>
    </div>
</div>

<style>
    .milestone {
        padding: 1rem;
        border-radius: 0.5rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 1rem;
        background-color: #F5F2EF;
    }

    .condition {
        display: flex;
        flex-shrink: 0;
    }

    .rewards {
        flex-grow: 1;
    }

    .actions {
        display: flex;
        flex-shrink: 0;
    }

    .stamps {
        flex-basis: 10ch;
        flex-shrink: 0;
    }

    .arrow {
        display: inline-block;
        margin-inline-start: 0.5rem;
        margin-inline-end: 0.5rem;
        color: #E0D8D2;
    }
</style>